import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable()
export class StatusService {
    status;
    constructor() {}
    setStatus(data) {
        this.status = data;
    }
    getStatus() {
        return this.status;
    }
    resetStatus() {
        this.status = '';
    }
}